import { render } from "./RightSide.vue?vue&type=template&id=6c64b1c1&scoped=true"
import script from "./RightSide.vue?vue&type=script&lang=js"
export * from "./RightSide.vue?vue&type=script&lang=js"

import "./RightSide.vue?vue&type=style&index=0&id=6c64b1c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c64b1c1"]])

export default __exports__